export default function responsiveImages(
  images,
  display = "block",
  margin = "0 auto",
  maxWidth = "100%",
  borderRadius = "44px"
) {
  if (images.length >= 2) {
    return (
      <picture style={{ display: "block" }}>
        <source media="(max-width: 990px)" srcSet={images[0].url} />
        <source media="(min-width: 991px)" srcSet={images[1].url} />
        <img
          src={images[0].url}
          alt={images[0].altTag}
          style={{
            display,
            margin,
            maxWidth,
            borderRadius
          }}
        />
      </picture>
    );
  }
  return null;
}
